module.exports = __webpack_public_path__ + "img/nome_scarpa_1.6f9efa0e.svg";